<template>
  <div class="nav-bar">
    <ul class="nav-bar__nav-list">
      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="active"
          :to="vueRoutes.dashboard"
          @click="$emit('close-details')"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="23"
            viewBox="0 0 25 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.4541 13.5444C18.0009 13.5444 18.4875 13.3368 18.914 12.9215C19.3406 12.5063 19.5538 12.0218 19.5538 11.4681C19.5538 10.9356 19.3406 10.4671 18.914 10.0625C18.4875 9.65787 18.0009 9.45555 17.4541 9.45555C16.9073 9.45555 16.4206 9.65787 15.9941 10.0625C15.5676 10.4671 15.3543 10.9356 15.3543 11.4681C15.3543 12.0218 15.5676 12.5063 15.9941 12.9215C16.4206 13.3368 16.9073 13.5444 17.4541 13.5444ZM1.9685 19.3903C1.9685 19.3903 1.9685 19.6725 1.9685 20.2368C1.9685 20.8012 1.9685 21.0833 1.9685 21.0833V1.91667C1.9685 1.91667 1.9685 2.20417 1.9685 2.77917C1.9685 3.35417 1.9685 3.64167 1.9685 3.64167C1.9685 3.64167 1.9685 4.0463 1.9685 4.85556C1.9685 5.66481 1.9685 6.67639 1.9685 7.89028V15.1417C1.9685 16.3556 1.9685 17.3671 1.9685 18.1764C1.9685 18.9856 1.9685 19.3903 1.9685 19.3903ZM1.9685 23C1.46544 23 1.01159 22.8083 0.606956 22.425C0.202319 22.0417 0 21.5944 0 21.0833V1.91667C0 1.42685 0.202319 0.984954 0.606956 0.590972C1.01159 0.196991 1.46544 0 1.9685 0H21.6535C22.1785 0 22.6378 0.196991 23.0315 0.590972C23.4252 0.984954 23.622 1.42685 23.622 1.91667V6.19722H21.6535V1.91667H1.9685V21.0833H21.6535V16.8347H23.622V21.0833C23.622 21.5944 23.4252 22.0417 23.0315 22.425C22.6378 22.8083 22.1785 23 21.6535 23H1.9685ZM13.7139 17.4736C12.9703 17.4736 12.3797 17.2606 11.9423 16.8347C11.5048 16.4088 11.2861 15.8444 11.2861 15.1417V7.89028C11.2861 7.1662 11.5048 6.59653 11.9423 6.18125C12.3797 5.76597 12.9703 5.55833 13.7139 5.55833H22.5722C23.3158 5.55833 23.9064 5.76597 24.3438 6.18125C24.7813 6.59653 25 7.1662 25 7.89028V15.1417C25 15.8444 24.7813 16.4088 24.3438 16.8347C23.9064 17.2606 23.3158 17.4736 22.5722 17.4736H13.7139ZM23.0315 15.5569V7.475H13.2546V15.5569H23.0315Z"
            />
          </svg>

          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.dashboard') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="active"
          :to="vueRoutes.users"
          @click="$emit('close-details')"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4987 11.9411C10.8945 11.9411 9.58203 11.4094 8.5612 10.346C7.54036 9.28266 7.02995 7.91547 7.02995 6.24447C7.02995 4.57346 7.54036 3.20627 8.5612 2.1429C9.58203 1.07954 10.8945 0.547852 12.4987 0.547852C14.1029 0.547852 15.4154 1.07954 16.4362 2.1429C17.457 3.20627 17.9674 4.57346 17.9674 6.24447C17.9674 7.91547 17.457 9.28266 16.4362 10.346C15.4154 11.4094 14.1029 11.9411 12.4987 11.9411ZM0.832031 24.1318V20.562C0.832031 19.5999 1.06293 18.777 1.52474 18.0934C1.98654 17.4098 2.58203 16.8908 3.3112 16.5363C4.93967 15.7768 6.5013 15.2071 7.99609 14.8274C9.49089 14.4476 10.9918 14.2577 12.4987 14.2577C14.0056 14.2577 15.5004 14.4539 16.9831 14.8464C18.4657 15.2388 20.0213 15.8021 21.6497 16.5363C22.4032 16.8908 23.0108 17.4098 23.4727 18.0934C23.9345 18.777 24.1654 19.5999 24.1654 20.562V24.1318H0.832031ZM3.01953 21.8532H21.9779V20.562C21.9779 20.1569 21.8624 19.7708 21.6315 19.4036C21.4006 19.0365 21.115 18.7644 20.7747 18.5871C19.2192 17.8023 17.7973 17.2642 16.5091 16.9731C15.2209 16.6819 13.8841 16.5363 12.4987 16.5363C11.1133 16.5363 9.76432 16.6819 8.45182 16.9731C7.13932 17.2642 5.71745 17.8023 4.1862 18.5871C3.84592 18.7644 3.56641 19.0365 3.34766 19.4036C3.12891 19.7708 3.01953 20.1569 3.01953 20.562V21.8532ZM12.4987 9.66243C13.4466 9.66243 14.2305 9.33963 14.8503 8.69401C15.4701 8.04839 15.7799 7.23188 15.7799 6.24447C15.7799 5.25705 15.4701 4.44054 14.8503 3.79492C14.2305 3.14931 13.4466 2.8265 12.4987 2.8265C11.5508 2.8265 10.7669 3.14931 10.1471 3.79492C9.52734 4.44054 9.21745 5.25705 9.21745 6.24447C9.21745 7.23188 9.52734 8.04839 10.1471 8.69401C10.7669 9.33963 11.5508 9.66243 12.4987 9.66243Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.users-lbl') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="active"
          :to="vueRoutes.realEstate"
          @click="$emit('close-details')"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.16667 13.5417H7.29167V15.625H4.16667V13.5417ZM9.375 15.625H12.5V13.5417H9.375V15.625ZM4.16667 19.7917H7.29167V17.7083H4.16667V19.7917ZM9.375 19.7917H12.5V17.7083H9.375V19.7917ZM4.16667 7.29167H7.29167V5.20833H4.16667V7.29167ZM9.375 7.29167H12.5V5.20833H9.375V7.29167ZM4.16667 11.4583H7.29167V9.375H4.16667V11.4583ZM9.375 11.4583H12.5V9.375H9.375V11.4583ZM25 8.33333V25H0V3.125C0 2.2962 0.32924 1.50134 0.915291 0.915291C1.50134 0.32924 2.2962 0 3.125 0L13.5417 0C14.3705 0 15.1653 0.32924 15.7514 0.915291C16.3374 1.50134 16.6667 2.2962 16.6667 3.125V5.20833H21.875C22.7038 5.20833 23.4987 5.53757 24.0847 6.12362C24.6708 6.70968 25 7.50453 25 8.33333ZM14.5833 3.125C14.5833 2.84873 14.4736 2.58378 14.2782 2.38843C14.0829 2.19308 13.8179 2.08333 13.5417 2.08333H3.125C2.84873 2.08333 2.58378 2.19308 2.38843 2.38843C2.19308 2.58378 2.08333 2.84873 2.08333 3.125V22.9167H14.5833V3.125ZM22.9167 8.33333C22.9167 8.05707 22.8069 7.79211 22.6116 7.59676C22.4162 7.40141 22.1513 7.29167 21.875 7.29167H16.6667V22.9167H22.9167V8.33333ZM18.75 15.625H20.8333V13.5417H18.75V15.625ZM18.75 19.7917H20.8333V17.7083H18.75V19.7917ZM18.75 11.4583H20.8333V9.375H18.75V11.4583Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.real-estate-lbl') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="active"
          :to="vueRoutes.contracts"
          @click="$emit('close-details')"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.81854 4.68172V1.27263C5.81854 0.971248 5.93826 0.682209 6.15137 0.4691C6.36448 0.25599 6.65352 0.136267 6.9549 0.136267H16.0458C16.3472 0.136267 16.6362 0.25599 16.8493 0.4691C17.0625 0.682209 17.1822 0.971248 17.1822 1.27263V4.68172H21.7276C22.029 4.68172 22.318 4.80145 22.5312 5.01455C22.7443 5.22766 22.864 5.5167 22.864 5.81809V21.7272C22.864 22.0286 22.7443 22.3176 22.5312 22.5307C22.318 22.7438 22.029 22.8635 21.7276 22.8635H1.27308C0.9717 22.8635 0.682661 22.7438 0.469552 22.5307C0.256442 22.3176 0.136719 22.0286 0.136719 21.7272V5.81809C0.136719 5.5167 0.256442 5.22766 0.469552 5.01455C0.682661 4.80145 0.9717 4.68172 1.27308 4.68172H5.81854ZM2.40945 6.95445V20.5908H20.5913V6.95445H2.40945ZM8.09126 2.40899V4.68172H14.9094V2.40899H8.09126Z"
            />
          </svg>
          <!--eslint-enable-->
          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.contracts-lbl') }}
          </span>
        </router-link>
      </li>

      <li class="nav-bar__nav-item">
        <router-link
          class="nav-bar__nav-link"
          active-class="active"
          :to="vueRoutes.approvals"
          @click="$emit('close-details')"
        >
          <!--eslint-disable-->
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.9167 24.9999H2.08333V22.9166H22.9167V24.9999ZM25 16.6666C25 14.9437 23.5979 13.5416 21.875 13.5416H16.6667C16.2458 13.5416 15.9875 13.3093 15.8698 13.1708C15.7531 13.0322 15.5687 12.7374 15.6406 12.3229C16.2437 8.85306 16.6656 5.49994 16.6656 4.16764C16.6656 1.86973 14.7969 0.000976562 12.499 0.000976562C10.201 0.000976562 8.33229 1.86973 8.33229 4.16764C8.33229 5.49785 8.75417 8.85202 9.35833 12.3229C9.43021 12.7374 9.24583 13.0322 9.12917 13.1708C9.0125 13.3093 8.75417 13.5416 8.33229 13.5416H3.125C1.40208 13.5416 0 14.9437 0 16.6666V20.8333H25V16.6666ZM2.08333 16.6666C2.08333 16.0926 2.55104 15.6249 3.125 15.6249H8.33333C9.25729 15.6249 10.1292 15.2187 10.724 14.5114C11.3187 13.8031 11.5698 12.876 11.4115 11.9645C10.8344 8.65098 10.4156 5.37077 10.4156 4.1666C10.4156 3.01764 11.35 2.08327 12.499 2.08327C13.6479 2.08327 14.5823 3.01764 14.5823 4.1666C14.5823 5.37389 14.1646 8.65306 13.5875 11.9645C13.4292 12.8749 13.6792 13.8031 14.274 14.5104C14.8698 15.2187 15.7406 15.6239 16.6656 15.6239H21.874C22.449 15.6239 22.9156 16.0916 22.9156 16.6656V18.7489H2.08333V16.6656V16.6666Z"
            />
          </svg>
          <!--eslint-enable-->

          <span class="nav-bar__nav-link-name">
            {{ $t('side-bar.nav-bar.coordination-lbl') }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';
import { vueRoutes } from '@/router/route-const';

export default {
  emits: ['close-details'],

  setup() {
    let isRealEstate = ref(false);
    let isWallet = ref(false);

    return {
      isRealEstate,
      vueRoutes,
      isWallet,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/mixins';

.nav-bar {
  &__nav-item-nav {
    padding-left: 4rem;
  }

  &__nav-link {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 1.2rem 0;
    max-width: 18.2rem;
    max-height: 3rem;
    border-top-right-radius: 0.8rem;
    border-bottom-right-radius: 0.8rem;

    &-nav-link {
      font-size: 1.1rem;
      font-weight: 400;

      &-active {
        color: $mobile-bg;
        background-color: $col-primary;
      }
    }

    & svg {
      fill: $col-link;
    }
    & span {
      color: $col-link;
      font-size: 1.3rem;
      font-weight: 500;
      padding-left: 1.5rem;
    }

    &.active {
      margin-left: -3.07rem;
      padding: 0.5rem 0 0.5rem 3rem;
      background-color: $col-primary;

      & svg {
        fill: $mobile-bg;
      }
      & span {
        color: $mobile-bg;
      }
    }
  }
  &__nav-link-active {
    & svg {
      fill: $mobile-bg;
    }
    & span {
      color: $mobile-bg;
    }
  }
}
</style>
